export const ActionTypes = {
    GET_ROLE_BY_ID: "GET_ROLE_BY_ID",
    GET_USER_BY_ID: "GET_USER_BY_ID",
    GET_ROLE_LIST:"GET_ROLE_LIST",
    GET_USER_LIST:"GET_USER_LIST",
    GET_ACTIVITY_LIST:"GET_ACTIVITY_LIST",
    SET_ACTIVITY_FILTER: "SET_ACTIVITY_FILTER",
    GET_TOTAL_ACTIVITY_COUNT: "GET_TOTAL_ACTIVITY_COUNT",
    RESET_ACTIVITY_LIST: "RESET_ACTIVITY_LIST",
    RESET_STATE: "RESET_STATE",
    GET_STATISTICS_DATA: "GET_STATISTICS_DATA",
    SET_TENANT_GROUP_DATA: "SET_TENANT_GROUP_DATA"
};